// walkthrough-state — localStorage-backed flag for "has this parent
// seen the 4-screen onboarding tour?"
//
// Versioned so a future revision (different screens, different copy)
// re-shows the tour to everyone without code changes elsewhere — bump
// WALKTHROUGH_VERSION and the existing "v1=done" entries become stale.

export const WALKTHROUGH_VERSION = "v1";
const KEY = `sms.parent.walkthrough.${WALKTHROUGH_VERSION}`;

export function isWalkthroughSeen(): boolean {
  try {
    return window.localStorage.getItem(KEY) === "done";
  } catch (_) {
    // Private mode / disabled storage / SSR — treat as "unseen" so
    // the parent sees the tour. Skip button is always available.
    return false;
  }
}

export function markWalkthroughSeen(): void {
  try {
    window.localStorage.setItem(KEY, "done");
  } catch (_) {
    /* ignore quota / private-mode errors */
  }
}

/** Test-only + Settings "Take the tour again" path. Clears the flag
 *  so the next TodayWidget mount re-shows the walkthrough. */
export function resetWalkthroughForReplay(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch (_) {
    /* ignore */
  }
}
